import React, { useContext } from "react";
import { MovieContext } from "../contexts/MovieContext";
import MovieDetails from "./MovieDetails";

export default function MovieList() {
  const { movies } = useContext(MovieContext);

  return movies.length ? (
    <div className="movie-list">
      <ul>
        {movies.map(movie => (
          <MovieDetails key={movie.id} movie={movie} />
        ))}
      </ul>
    </div>
  ) : (
    <div className="empty">No movies to watch. Hello free time!</div>
  );
}
